import { TemplateDTO } from '../../models';
/**
 * 模版信息正确性校验
 * @param  {TemplateDTO} 模版对象
 */

export function templateCheck(templateDTO: TemplateDTO) {
  if (!templateDTO) {
    return;
  }

  const {
    name = undefined,
    template,
    url
  } = templateDTO; // 是否存在 模版 JSON 或 模版 URL

  if (!template && !url) {
    console.warn('DX 模版错误 - 没有模版或 URL:', url, name || '');
    return false;
  } // 校验模版 URL 是以 .js 结尾


  if (url && !url.endsWith('.js')) {
    console.warn('DX 模版错误 - URL 不合法:', url, name || '');
    return false;
  } // 过滤一些暂时无法渲染的模版
  // 比如 App 所用的 icbu_vv 打头的 VV 模版


  if (name && name.startsWith('icbu_vv')) {
    console.warn('DX 模版错误 - 跳过 DX 模版渲染：', name || '');
    return false;
  }

  return true;
}